import { UserModel, DefaultServiceResult } from '@/types';

export interface UserServiceGetAllParams {
    page: number;
    per_page: number;
    order_by: string;
    is_active?: boolean;
    is_agent?: boolean;
    use_auto_attendant?: boolean;
    roles?: number[];
    search?: string;
}

export interface UserServiceCreateResult extends DefaultServiceResult {
    result: UserModel;
}

export interface UserServiceUpdatePasswordBody {
    password: string;
    token?: string;
}

export interface UserServicCheckExtensionNumberBody {
    id: number | null;
    levelId: number | null;
    number: number | null;
}
